module.exports = __webpack_public_path__ + "static/media/arrow-icon-green.ef6b7408.svg";